import { graphql } from '~/graphql';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';
import type { PlatformProductCategory } from '~/graphql/graphql';

export const useGetProductPropertyKeysWithValues = (
  category: PlatformProductCategory | undefined | null
) => {
  return useGraphqlQuery(
    graphql(`
      query ProductPropertyKeysWithValues($category: PlatformProductCategory!) {
        productPropertyKeysWithValues(category: $category) {
          key
          displayName
          isArray
          values {
            value
            displayValue
          }
        }
      }
    `),
    ['productPropertyKeysWithValues', category ?? ''],
    { category: category as PlatformProductCategory },
    { enabled: !!category, staleTime: 1000 * 60 * 30, gcTime: 1000 * 60 * 35 }
  );
};

export const useGetPropertyValues = (
  category: PlatformProductCategory | undefined | null,
  key: string | null | undefined
) => {
  const document = graphql(`
    query PropertyValues($category: PlatformProductCategory!, $key: String!) {
      productPropertyValues(category: $category, key: $key) {
        value
        displayValue
      }
    }
  `);

  const isEnabled = !!category && !!key;

  return useGraphqlQuery(
    document,
    ['propertyValues', category ?? '', key ?? ''],
    {
      category: category as PlatformProductCategory,
      key: key as string,
    },
    { enabled: isEnabled }
  );
};
